import * as React from "react";

import { cva } from "class-variance-authority";

import { cn } from "../../utils";

export const textareaVariants = cva(
  "af-flex af-min-h-[80px] af-w-full af-rounded-md af-border af-border-input af-bg-background af-px-3 af-py-2 af-text-base af-ring-offset-background placeholder:af-text-muted-foreground focus-visible:af-outline-none focus-visible:af-ring-2 focus-visible:af-ring-ring focus-visible:af-ring-offset-2 disabled:af-cursor-not-allowed disabled:af-opacity-50 md:af-text-sm",
);

const Textarea = ({
  className,
  ...props
}: React.ComponentProps<"textarea">) => {
  return <textarea className={cn(textareaVariants(), className)} {...props} />;
};
Textarea.displayName = "Textarea";

export { Textarea };
